import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import Guid from "_shared/guids/guid";
import _ from "lodash";
import CompanyProfile from "marketplace/companies/profiles/company-profile";

export default class UpdateMarketplaceCompanyAPIRequest {
  public payload: JsonPatchOperation[] = [];

  public constructor(
    isVisible?: boolean,
    contactId?: Guid,
    originalProfile?: CompanyProfile,
    updatedProfile?: CompanyProfile,
  ) {
    if (isVisible !== undefined) {
      this.payload.push({
        op: "replace",
        path: "/isVisible",
        value: isVisible,
      });
    }
    if (contactId) {
      this.payload.push({
        op: "replace",
        path: "/contactId",
        value: contactId?.value,
      });
    }

    if (originalProfile && updatedProfile) {
      if (!updatedProfile.name) throw new Error("Company name is required");
      this.addProfilePatch("name", updatedProfile.name, originalProfile.name);
      this.addProfilePatch("yearEstablished", updatedProfile.yearEstablished, originalProfile.yearEstablished);
      this.addProfilePatch("numberOfEmployees", updatedProfile.numberOfEmployees, originalProfile.numberOfEmployees);
      this.addProfilePatch("description", updatedProfile.description, originalProfile.description);
      this.addProfilePatch("location", updatedProfile.location, originalProfile.location);
      if (updatedProfile.website?.toString() !== originalProfile.website?.toString()) {
        this.payload.push({
          op: "replace",
          path: "/website",
          value: updatedProfile.website?.toString(),
        });
      }
      if (!_.isEqual(updatedProfile.categories, originalProfile.categories)) {
        this.payload.push({
          op: "replace",
          path: "/categories",
          value: updatedProfile.categories,
        });
      }
    }
  }

  private addProfilePatch(field: string, updatedValue: unknown, originalValue: unknown) {
    if (updatedValue !== originalValue) {
      this.payload.push({
        op: "replace",
        path: `/${field}`,
        value: updatedValue,
      });
    }
  }
}
